export default {
  女装: "ເຄື່ອງນຸ່ງຜູ້ຍິງ",
  男装: "ຜູ້ຊາຍ",
  手机和小工具: "ໂທລະສັບມືຖືແລະເຄື່ອງມືນ້ອຍ",
  居家生活: "ຊີວິດໃນບ້ານ",
  电脑及周边设备: "ອຸປະກອນຄອມພິວເຕີແລະອຸປະກອນເສີມ",
  美容及个人护理: "ຄວາມງາມແລະການດູແລສ່ວນຕົວ",
  家用电器: "ເຄື່ອງຫຼີ້ນ",
  健康与保健: "ສຸຂະພາບແລະການຮັກສາສຸຂະພາບ",
  食品和饮料: "ອາຫານແລະເຄື່ອງດື່ມ",
  玩具_儿童和婴儿: "ຂອງຫຼິ້ນ, ເດັກນ້ອຍແລະເດັກນ້ອຍ",
  童装时尚: "ເຄື່ອງນຸ່ງເດັກນ້ອຍແຟຊັ່ນ",
  视频游戏: "ເກມວີດີໂອ",
  运动与户外: "ອອກກໍາລັງກາຍແລະນອກ",
  爱好与书籍: "ອະດິເລກແລະປື້ມ",
  相机和无人机: "ກ້ອງຖ່າຍຮູບແລະ drones",
  宠物食品及用品: "ອາຫານສັດລ້ຽງແລະເຄື່ອງໃຊ້",
  女士包袋: "ກະເປົາຜູ້ຍິງ",
  男士包袋: "ກະເປົາຜູ້ຊາຍ",
  珠宝及配饰: "ເຄື່ອງປະດັບແລະອຸປະກອນເສີມ",
  手表: "ຜົກ",
  女鞋: "ເກີບຜູ້ຍິງ",
  男装鞋: "ເກີບຜູ້ຊາຍ",
  汽车: "ລົດຢົນ",
  我附近的ShopeePay: "shopeepay ຂອງຂ້າພະເຈົ້າໃກ້ຄຽງຂອງຂ້າພະເຈົ້າ",
  餐饮_旅行和服务: "ບໍລິການ, ການເດີນທາງແລະການບໍລິການ",
  旅行及行李: "ການເດີນທາງແລະກະເປົາ",
  各种各样的: "ຕ່າງໆ",
  我是来买什么的: "ຂ້ອຍຢູ່ທີ່ນີ້ເພື່ອຊື້",
  对不起_找不到_相关的商品:
    "ຂໍໂທດ, ທ່ານບໍ່ສາມາດຊອກຫາ [{0}] ຜະລິດຕະພັນທີ່ກ່ຽວຂ້ອງ",
  类别: "ປະເພດ",
  产品: "ຜະລິດຕະພັນ",
  店铺: "ຮ້ານຄ້າ",
  首页: "ຫນ້າທາງຫນ້າ",
  限时秒杀: "ເວລາຈໍາກັດ Spike",
  博客: "Blog",
  所有品牌: "ທຸກຍີ່ຫໍ້",
  所有类别: "ຫມວດຫມູ່",
  我的购物车: "ລົດເຂັນຂອງຂ້ອຍ",
  发货信息: "ຂໍ້ມູນການສົ່ງ",
  交货信息: "ຂໍ້ມູນການສົ່ງ",
  付款: "ການຊໍານານ",
  确认: "ຢືນຢັນ",
  您的购物车是空的: "ກະຕ່າສິນຄ້າຂອງທ່ານແມ່ນຫວ່າງເປົ່າ",
  价格: "ລາຄາ",
  税: "ພາສີ",
  数量: "ປະລິມານ",
  总计: "ທັງຫມົດ",
  移除: "ເອົາອອກ",
  返回商店: "ກັບໄປຮ້ານ",
  继续发货: "ສືບຕໍ່ການຈັດສົ່ງ",
  筛选: "ຕອງ",
  价格范围: "ລາຄາ",
  排序方式: "ຄັດໂດຍ",
  最新: "ເຖິງວັນທີ",
  最旧: "ແກ່",
  价格从低到高: "ລາຄາຈາກຕ່ໍາຫາສູງ",
  价格从高到低: "ລາຄາຈາກສູງເຖິງຕ່ໍາ",
  选择交货类型: "ເລືອກປະເພດການຈັດສົ່ງ",
  送货上门: "ສົ່ງສັນ",
  继续付款: "ສືບຕໍ່ຈ່າຍ",
  任何其他信息: "ຂໍ້ມູນອື່ນໆ",
  或者: "ຫຼື",
  您的钱包余额: "ຍອດເງິນຂອງທ່ານ",
  余额不足: "ການດຸ່ນດ່ຽງບໍ່ພຽງພໍ",
  支付: "ຈ່າຍ",
  我同意: "ຂ້າພະເຈົ້າຕົກລົງເຫັນດີ",
  条款和条件: "ຂໍ້ກໍານົດແລະເງື່ອນໄຂ",
  退货政策: "ນະໂຍບາຍກັບຄືນ",
  隐私政策: "ຄວາມເປັນສ່ວນຕົວ",
  概括: "ສະຫຼຸບ",
  项目: "ໂຄງການ",
  全部的: "ທັງຫມົດ -round",
  小计: "ແຕ້ມ",
  总运费: "ການຂົນສົ່ງສິນຄ້າທັງຫມົດ",
  有优惠码吗_在这里输入: "ມີລະຫັດຫຼຸດລາຄາບໍ? ໃສ່ບ່ອນນີ້",
  申请: "ສະຫມັກ",
  编辑: "ແກ້ໄຂ",
  删除: "ລົບ",
  添加新地址: "ເພີ່ມທີ່ຢູ່ໃຫມ່",
  继续交货信息: "ສືບຕໍ່ຂໍ້ມູນການສົ່ງ",
  选择一个地址: "ເລືອກທີ່ຢູ່",
  购买历史: "ຊື້ປະຫວັດ",
  下载: "ດາວໂຫລດ",
  已发送退款请求: "ການຮ້ອງຂໍເງິນຄືນສົ່ງການຮ້ອງຂໍເງິນຄືນ",
  对比: "ຄວາມແຕກຕ່າງ",
  对话: "ການສ້ອມແປງ",
  我的钱包: "ກະເປົາເງິນຂອງຂ້ອຍ",
  工单: "ການສັ່ງຊື້",
  管理个人资料: "ຈັດການຂໍ້ມູນສ່ວນຕົວ",
  登出: "ອອກຈາກລະບົບ",
  重置对比列表: "ປັບລາຍຊື່ການປຽບທຽບ",
  您的对比列表为空: "ບັນຊີລາຍຊື່ການປຽບທຽບຂອງທ່ານແມ່ນຫວ່າງເປົ່າ",
  在您的购物车中: "ໃນລົດເຂັນຂອງທ່ານ",
  在您的愿望清单中: "ໃນບັນຊີທີ່ທ່ານຕ້ອງການ",
  在您的预定列表中: "ໃນບັນຊີລາຍຊື່ກໍານົດຂອງທ່ານ",
  下载您的产品: "ດາວໂຫລດຜະລິດຕະພັນຂອງທ່ານ",
  选项: "ຕົວເລືອກ",
  什么都没找到: "ຂ້ອຍບໍ່ພົບຫຍັງເລີຍ",
  特色产品: "ສິນຄ້າພິເສດ",
  最畅销: "ທີ່ດີທີ່ສຸດ",
  前_名: "{0} ຊື່",
  查看更多: "ເບິ່ງເພີ່ມເຕີມ",
  查看所有类别: "ເບິ່ງທຸກປະເພດ",
  十大品牌: "10 ອັນດັບທີ່ດີທີ່ສຸດ",
  查看所有品牌: "ເບິ່ງຍີ່ຫໍ້ທັງຫມົດ",
  登录: "ເຂົ້າສູ່ລະບົບ",
  手机号码: "ເບີໂທລະສັບ",
  密码: "ລະຫັດຜ່ານ",
  密码长度为6到16个字符: "ຄວາມຍາວລະຫັດຜ່ານແມ່ນ 6 ເຖິງ 16 ຕົວອັກສອນ",
  验证码: "ລະຫັດຢືນຢັນ",
  登录中: "ເຂົ້າສູ່ລະບົບ",
  游客登录: "ເຂົ້າສູ່ລະບົບການທ່ອງທ່ຽວ",
  注册您的商店: "ລົງທະບຽນຮ້ານຂອງທ່ານ",
  现在申请: "ສະຫມັກດຽວນີ້",
  成为商家: "ກາຍເປັນພໍ່ຄ້າ",
  现在注册: "ລົງທະບຽນດຽວນີ້",
  登录成功: "ເຂົ້າສູ່ລະບົບທີ່ປະສົບຜົນສໍາເລັດ",
  通知: "ບອກເລົ່າ",
  未找到通知: "ບໍ່ມີການແຈ້ງເຕືອນ",
  评论: "ຄໍາເຫັນ",
  估计运输时间: "ເວລາຂົນສົ່ງທີ່ຄາດຄະເນ",
  天: "ຟ້າແຖນ",
  所售: "ຂາຍ",
  给商家留言: "ອອກຂໍ້ຄວາມໃຫ້ພໍ່ຄ້າ",
  规格: "ການສະເພາະ",
  库存: "ໃນສາງ",
  总价: "ລາຄາທົ່ວໄປ",
  添加到购物车: "ຕື່ມໃສ່ກະຕ່າ",
  立即购买: "ຊື້ດຽວນີ້",
  缺货: "ອອກຈາກຫຼັກຊັບ",
  添加到愿望清单: "ຕື່ມໃສ່ລາຍຊື່ທີ່ຕ້ອງການ",
  加入对比列表: "ເພີ່ມລາຍຊື່ປຽບທຽບ",
  退款: "ການຈ່າຢເງິນ",
  查看条款: "ວິກເຄາະ",
  分享: "ສ່ວນ",
  描述: "ພັນລະນາ",
  相关产品: "ຜະລິດຕະພັນທີ່ກ່ຽວຂ້ອງ",
  没有人问过商家: "ບໍ່ມີໃຜຖາມພໍ່ຄ້າ",
  该产品暂无评论: "ບໍ່ມີຄວາມເຫັນໃດໆກ່ຽວກັບຜະລິດຕະພັນນີ້",
  客户评论: "ຄໍາເຫັນຂອງລູກຄ້າ",
  访问商店: "ຢ້ຽມຢາມຮ້ານ",
  畅销产品: "ຜະລິດຕະພັນທີ່ດີທີ່ສຸດ",
  日期: "ວັນທີ",
  订单编号: "ເລກສັ່ງ",
  总额: "ຈໍານວນກ້ອນ",
  状态: "ລັດ",
  愿望清单: "ບັນຊີຕ້ອງການ",
  还没有添加任何东西: "ຍັງບໍ່ໄດ້ເພີ່ມຫຍັງເທື່ອ",
  注册: "ລົງທະບຽນ",
  邀请码: "ລະຫັດເຊີນ",
  请输入邀请码: "ກະລຸນາໃສ່ລະຫັດເຊີນ",
  用户名: "ສັນຍາລັກ",
  请输入用户名: "ກະລຸນາໃສ່ຊື່ຜູ້ໃຊ້",
  用户名长度为6_14个字符: "ຄວາມຍາວຊື່ຜູ້ໃຊ້ແມ່ນ 6-14 ຕົວອັກສອນ",
  昵称: "ຊື່ Nick",
  请输入手机号码: "ກະລຸນາໃສ່ເບີໂທລະສັບມືຖື",
  手机号码格式错误: "ໂທລະສັບມືຖືເບີໂທລະສັບມືຖື",
  密码长度为6_16个字符: "ຄວາມຍາວລະຫັດຜ່ານແມ່ນ 6-16 ຕົວອັກສອນ",
  确认密码: "ຢືນຢັນລະຫັດຜ່ານ",
  请输入确认密码: "ກະລຸນາໃສ່ລະຫັດຢືນຢັນ",
  提款密码: "ລະຫັດຜ່ານຖອນ",
  请输入提款密码: "ກະລຸນາໃສ່ລະຫັດຖອນເງິນ",
  提款密码长度为4_16个字符: "ຄວາມຍາວຂອງລະຫັດຜ່ານການຖອນແມ່ນ 4-16 ຕົວອັກສອນ",
  请输入验证码: "ກະລຸນາໃສ່ລະຫັດຢັ້ງຢືນ",
  在_s后发送: "ສົ່ງຫຼັງ {0} s",
  发送验证码: "ສົ່ງລະຫັດຢືນຢັນ",
  注册即表示您同意我们的条款和条件:
    "ການລົງທະບຽນຫມາຍຄວາມວ່າທ່ານເຫັນດີກັບຂໍ້ກໍານົດແລະເງື່ອນໄຂຂອງພວກເຮົາ.",
  创建账号: "ສ້າງບັນຊີ",
  验证码发送成功: "ລະຫັດຢັ້ງຢືນສົ່ງໃຫ້ປະສົບຜົນສໍາເລັດ",
  确认密码不一致: "ຢືນຢັນວ່າລະຫັດຜ່ານແມ່ນບໍ່ສອດຄ່ອງ",
  提款密码必须为数字: "ລະຫັດຜ່ານການຖອນເງິນຕ້ອງຖືກນັບ",
  注册成功: "ລົງທະບຽນປະສົບຜົນສໍາເລັດ",
  购物车: "ລົດເຂັນ",
  账户: "ບັນຊີ",
  我的账户: "ບັນຊີຂອງຂ້ອຍ",
  已经有一个账户: "ມີບັນຊີແລ້ວ",
  新地址: "ທີ່ຢູ່ໃຫມ່",
  编辑地址: "ທີ່ຢູ່ Editor",
  保存: "ປະຢັດ",
  是否默认: "ບໍ່ວ່າຈະເປັນຄ່າເລີ່ມຕົ້ນ",
  具体地址: "ທີ່ຢູ່ສະເພາະ",
  请输入具体地址: "ກະລຸນາໃສ່ທີ່ຢູ່ສະເພາະ",
  地区: "ພື້ນທີ່",
  请输入地区: "ກະລຸນາໃສ່ພື້ນທີ່",
  城市: "ເມືອງ",
  请输入城市: "ກະລຸນາເຂົ້າເມືອງ",
  省份: "ແຂວງ",
  请输入省份: "ກະລຸນາເຂົ້າໄປໃນແຂວງ",
  邮政编码: "ລະຫັດໄປສະນີ",
  请输入邮政编码: "ກະລຸນາໃສ່ລະຫັດໄປສະນີ",
  电话号码: "ເບີໂທລະສັບ",
  请输入电话号码: "ກະລຸນາໃສ່ເບີໂທລະສັບ",
  收货人: "ຄົກກະດ້າງ",
  请输入收货人: "ກະລຸນາໃສ່ consignee",
  保存成功: "ປະສົບຜົນສໍາເລັດ",
  最畅销的商家: "ຜູ້ຄ້າຂາຍທີ່ດີທີ່ສຸດ",
  查看所有的商家: "ກວດເບິ່ງຜູ້ຄ້າຂາຍທຸກຄົນ",
  支持政策: "ນະໂຍບາຍສະຫນັບສະຫນູນ",
  您的电子邮件地址: "ທີ່ຢູ່ອີເມວຂອງທ່ານ",
  订阅: "ການຈອງຫນັງສືພິມ",
  联系方式: "ຂໍ້ມູນຕິດຕໍ່",
  地址: "ທີ່ຢູ່",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, Illinois, USA",
  快速链接: "ການເຊື່ອມຕໍ່ໄວ",
  商家政策: "ນະໂຍບາຍສິນຄ້າ",
  submit: "ຍື່ນສະເຫນີ",
  提款银行卡: "ບັດລາງວັນ",
  我的面板: "ກະດານຂອງຂ້ອຍ",
  提示: "ຄໍານາມ",
  确定登出吗: "ທ່ານແນ່ໃຈບໍ່ວ່າທ່ານເຂົ້າສູ່ລະບົບ?",
  确定: "ແນ່ນອນ",
  取消: "ຍົກເລີກ",
  项目添加到您的购物车: "ໂຄງການດັ່ງກ່າວໄດ້ຖືກເພີ່ມເຂົ້າໃນກະຕ່າສິນຄ້າຂອງທ່ານ",
  经常一起购买: "ຊື້ເລື້ອຍໆ",
  返回购物: "ການໄປຊື້ເຄື່ອງກັບຄືນ",
  进行结算: "ດໍາເນີນການກັບເຊັກ",
  帮助热线: "ຊ່ວຍເຫຼືອສາຍດ່ວນ",
  查看所有通知: "ກວດເບິ່ງການແຈ້ງເຕືອນທັງຫມົດ",
  请输入密码: "ກະລຸນາໃສ່ລະຫັດຜ່ານ",
  前往充值: "ໄປຖ້ຽວ",
  购物车物品: "ລົດເຂັນ",
  查看购物车: "ກວດເບິ່ງລົດເຂັນ",
  钱包余额: "ຍອດກະເປົາເງິນ",
  充值钱包: "ເພີ່ມມູນຄ່າໂທ",
  钱包充值_线下_: "ກະເປົາເງິນກະເປົາເງິນ (Offline)",
  申请提款: "ສະຫມັກຂໍການຖອນ",
  钱包收支明细: "ລາຍໄດ້ແລະລາຍຈ່າຍລາຍຈ່າຍຂອງ Wallet",
  批准: "ອະນຸມັດ",
  提现历史记录: "ບັນທຶກປະຫວັດສາດການທົດແທນທີ່",
  类型: "ປະເພດ",
  信息: "ຂໍ້ມູນຂ່າວສານ",
  付款方式: "ວິທີການຊໍາລະເງິນ",
  请选择付款方式: "ກະລຸນາເລືອກວິທີການຈ່າຍເງິນ",
  Bill_Type_RECHARGE_BACK: "ການເຕີມເງິນພື້ນຫລັງ",
  Bill_Type_RECHARGE_ONLINE: "ເພີ່ມເຕີມ online",
  Bill_Type_RECHARGE_REGISTER: "ລົງທະບຽນ",
  Bill_Type_RECHARGE_JACKPOT: "ສາກໄຟ",
  Bill_Type_RECHARGE_PRESENT: "ລາງວັນເພີ່ມເຕີມ",
  Bill_Type_RECHARGE_FROM_COMMISSION: "ການໂອນເງິນຄະນະກໍາມະການ",
  Bill_Type_RECHARGE_TG_COMMISSION: "ຄະນະກໍາມະການສົ່ງເສີມການສົ່ງເສີມ",
  Bill_Type_REGISTER_TG_COMMISSION: "ຄ່າບໍລິການຄະນະກໍາມະການສົ່ງເສີມ",
  Bill_Type_WITHDRAW: "ຖົກຖອນ",
  Bill_Type_WITHDRAW_REJECT: "ຖົກຖອນ",
  Bill_Type_DEDUCT_HANDLE: "ການລົບລ້າງຄູ່ມື",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "ສາກໄຟ",
  Bill_Type_MINING_PROFIT: "ລາຍໄດ້ຂຸດຄົ້ນບໍ່ແຮ່",
  Bill_Type_MINING_PROFIT_COMMISSION: "ຄະນະກໍາມະການສົ່ງເສີມລາຍໄດ້ຈາກການຂຸດຄົ້ນ",
  Bill_Type_VIP_UPGRADE: "ຍົກລະດັບ VIP",
  Bill_Type_FINANCE_BUY: "ການຄຸ້ມຄອງຜະລິດຕະພັນຄວາມຮັ່ງມີ",
  Bill_Type_FINANCE_CAPITAL_RETURN: "ການສະຫນັບສະຫນູນການເງິນຍອດເງິນ",
  Bill_Type_FINANCE_FEE: "ຄ່າທໍານຽມຈັດການດ້ານການເງິນ",
  Bill_Type_FINANCE_PROFIT: "ລາຍໄດ້ດ້ານການເງິນ",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "ການຊື້ຄະນະກໍາມະການສໍາລັບຜະລິດຕະພັນການຄຸ້ມຄອງຄວາມຮັ່ງມີ",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "ຄະນະກໍາມະການດໍາເນີນການຄຸ້ມຄອງຜະລິດຕະພັນຄວາມຮັ່ງມີ",
  Bill_Type_WHEEL_DRAW: "raffle tirtable ໃຫຍ່",
  Bill_Type_BUY: "ຊື້ສິນຄ້າ",
  Bill_Type_PAY_SHOP: "ຈ່າຍຄ່າສົ່ງເງິນ",
  Bill_Type_BUY_COMMISSION: "ຊື້ຄະນະກໍາມະການສິນຄ້າ",
  Bill_Type_DEPOSIT: "ເສຽເງິນຝາກ",
  Bill_Type_STORE_BUY: "ຊື້ສິນຄ້າ",
  Bill_Type_STORE_BUY_REFUND: "ຊື້ເງິນຄືນ",
  Bill_Type: "ປະເພດການປ່ຽນແປງຂອງຫນີ້",
  Before_Money: "ຈໍານວນທີ່ຜ່ານມາ",
  Deal_Money: "ຈໍານວນເງິນປ່ຽນບັນຊີ",
  After_Money: "ຈໍານວນຕໍ່ມາ",
  Bill_Time: "ເວລາປ່ຽນບັນຊີ",
  No_More_Data: "ບໍ່ມີຂໍ້ມູນອີກຕໍ່ໄປ",
  Apply_Money: "ຈໍານວນການສະຫມັກ",
  Apply_Time: "ເວລາສະຫມັກ",
  Withdraw_Info: "ຄ່າທໍານຽມການຈັດການ: {ຄ່າທໍານຽມ}, ບັນຊີ: {ເງິນ}",
  提款订单状态_CHECKING: "ໄດ້ຮັບການທົບທວນຄືນ",
  提款订单状态_TRANSFERRING: "ການໂອນຍ້າຍ",
  提款订单状态_PASS: "ຢືນຢັນ",
  提款订单状态_REJECT: "ປະຕິເສດ",
  暂无可用充值方式: "ບໍ່ມີວິທີການເຕີມທີ່ມີປະໂຫຍດ",
  钱包收款码: "ລະຫັດເກັບກໍາຂໍ້ມູນກະເປົາເງິນ",
  钱包地址: "ທີ່ຢູ່ກະເປົາເງິນ",
  金额限制: "ຈໍາກັດຈໍານວນ",
  复制: "ສໍາເນົາ",
  付款凭证: "ບັດເຕີມເງິນເດືອນ",
  收款银行: "ທະນາຄານຮັບ",
  收款人: "ເຄື່ອງເກັບເງິນສົດ",
  收款账号: "ບັນຊີໄດ້ຮັບ",
  付款银行: "ທະນາຄານຈ່າຍ",
  付款人: "ຜູ້ຈ່າຍ",
  付款账号: "ບັນຊີການຈ່າຍເງິນ",
  请输入付款银行: "ກະລຸນາໃສ່ທະນາຄານການຈ່າຍເງິນ",
  请输入付款人: "ກະລຸນາໃສ່ຜູ້ຈ່າຍເງິນ",
  请输入付款账号: "ກະລຸນາໃສ່ບັນຊີການຈ່າຍເງິນ",
  请上传付款凭证: "ກະລຸນາອັບໂຫລດບັດເຕີມເງິນເດືອນ",
  充值金额: "ຈໍານວນເງິນຄືນ",
  请输入充值金额: "ກະລຸນາໃສ່ຈໍານວນເງິນຕື່ມ",
  submitting: "ສົ່ງ ...",
  Confirm: "ຍື່ນສະເຫນີ",
  Commit_Success: "ການຍື່ນສະເຫນີທີ່ປະສົບຜົນສໍາເລັດ",
  balanceType_BALANCE: "ຕົບ",
  balanceType_COMMISSION: "ຄະນະກໍາມາທິການ",
  Balance: "ຍອດບັນຊີ",
  Wash_Money: "ການເຂົ້າຮ່ວມ",
  请选择银行账户: "ກະລຸນາເລືອກບັນຊີທະນາຄານ",
  卡号类型: "ເລກບັດ",
  提现金额: "ຈໍານວນການຖອນ",
  提款金额: "ຈໍານວນການຖອນ",
  不能为空: "ບໍ່ສາມາດຫວ່າງໄດ້",
  金额不正确: "ຈໍານວນທີ່ບໍ່ຖືກຕ້ອງ",
  please_input_withdraw_password: "ກະລຸນາໃສ່ລະຫັດຖອນເງິນ",
  withdraw_password_format_error:
    "ລະຫັດຜ່ານການຖອນເງິນຕ້ອງເປັນຕົວອັກສອນ 4-16-bit",
  Fee: "ຄ່າທໍານຽມການຈັດການ",
  实际到账: "ທີ່ຈິງ",
  交易币种: "ສະກຸນເງິນການຄ້າ",
  原始密码: "ລະຫັດຜ່ານເບື້ອງຕົ້ນ",
  confirm_password_error: "ລະຫັດຜ່ານໃນສອງປັດສະວະບໍ່ຖືກຕ້ອງ",
  save_success: "ປະສົບຜົນສໍາເລັດ",
  please_input: "ກະລຸນາໃສ່",
  old_password: "ລະຫັດຜ່ານເກົ່າ",
  new_password: "ລະຫັດລັບໃຫມ່",
  please_input_confirm_password: "ກະລຸນາຢືນຢັນລະຫັດຜ່ານອີກຄັ້ງ",
  没有找到符合条件的商品: "ບໍ່ສາມາດຊອກຫາຜະລິດຕະພັນທີ່ມີຄຸນວຸດທິ",
  Search: "ຄົ້ນຫາ",
  全部: "ທັງຫມົດ",
  EnumGoodsOrderState_USER_PAY: "ໄດ້ຮັບການແຈກຢາຍ",
  EnumGoodsOrderState_SHOP_PAY: "ການກະຈາຍ",
  EnumGoodsOrderState_SUCCESS: "ສໍາເລັດຮູບ",
  EnumGoodsOrderState_CANCEL: "ຍົກເລີກ",
  EnumGoodsOrderState_REFUND_SUCCESS: "ການຈ່າຢເງິນ",
  订单号: "ເລກສັ່ງ",
  用户名称: "ຊື່ຜູ້ໃຊ້",
  收益: "ລາຍໄດ້",
  支付时间: "ຈ່າຍເວລາ",
  配送时间: "ເວລາສົ່ງ",
  完成时间: "ເຕັມເວລາ",
  发货: "ກໍາປັ່ນ",
  全选: "ການເລືອກເຕັມ",
  物品已添加到愿望清单: "ລາຍການດັ່ງກ່າວໄດ້ຖືກເພີ່ມເຂົ້າໃນລາຍການທີ່ຕ້ອງການ",
  物品已添加到比较列表: "ລາຍການດັ່ງກ່າວໄດ້ຖືກເພີ່ມເຂົ້າໃນລາຍຊື່ການປຽບທຽບ",
  购买成功提示: "ຊົມເຊີຍ, ຊື້ຜົນສໍາເລັດ",
  订单列表: "ລາຍຊື່ຄໍາສັ່ງ",
  商品名: "ຊື່ຜະລິດຕະພັນ",
  图片: "ຮູບ",
  没有品牌: "ບໍ່ມີຍີ່ຫໍ້",
  基本信息: "ຂໍ້ມູນພື້ນຖານ",
  Account_Name: "ຊື່",
  Bank_Account: "ບັນຊີທະນາຄານ",
  Bank_Phone: "ເບີໂທລະສັບມືຖືສໍາຮອງ",
  IFSC: "IFSC",
  UPI: "ບັນຊີ UPI",
  PIX: "ເລກບັນຊີ PIX",
  CPF: "ບັນຊີ CPF",
  GCASH: "ບັນຊີ GCASS",
  POWWI: "ບັນຊີ Powwi",
  身份证号: "ເລກປະຈໍາຕົວ",
  Edit: "ຮື້ຟື້ນ",
  Delete: "ລົບ",
  Add: "ເພີ່ມຂຶ້ນ",
  Forget_Withdraw_Password: "ລືມດ້ວຍລະຫັດຖອນເງິນ",
  Bank_Card_Info: "ຂໍ້ມູນບັດຂອງທະນາຄານ",
  收款人地址: "ທີ່ຢູ່ Cashier",
  SWIFT: "ວ່ອງໄວ",
  Bank_Branch: "sub -branch ຊື່",
  分行代码: "ລະຫັດສາຂາ",
  银行地址: "ທີ່ຢູ່ຂອງທະນາຄານ",
  Email: "ອີເມວ",
  银行卡长度必须超过: "ຄວາມຍາວຂອງບັດທະນາຄານຕ້ອງເກີນ {ຄວາມຍາວ}",
  银行卡格式不正确: "ຮູບແບບບັດທະນາຄານແມ່ນບໍ່ຖືກຕ້ອງ",
  Do_you_confirm_delete: "ທ່ານຢືນຢັນການລຶບບໍ?",
  Please_Login_First: "ກະລຸນາເຂົ້າສູ່ລະບົບກ່ອນ",
  Bank_Name: "ຊື່ທະນາຄານ",
  Please_add_bank_first: "ທ່ານບໍ່ໄດ້ຜູກມັດບັດທະນາຄານ, ກະລຸນາຕື່ມກ່ອນ",
  withdrawType: "ການຖອນເງິນ",
  withdraw_money_limit:
    "ຈໍານວນເງິນຂອງການຖອນຕ້ອງແມ່ນໃຫຍ່ກວ່າ 0 ແລະຫນ້ອຍກ່ວາຫຼືເທົ່າກັບ {ຍອດ {ຍອດ}",
  withdraw_times_limit:
    "ທ່ານໄດ້ສະກັດ {InstwithDranumnum} ເວລາມື້ນີ້. ຫຼັງຈາກເວລາມື້ນີ້. ມັນມີຄວາມຕັ້ງໃຈທີ່ຈະຖອນເງິນບໍ?",
  Copy_Success: "ການຊ້ໍາອີກ",
  商店首页: "ເກັບຮັກສາຫນ້າທໍາອິດ",
  所有产品: "ຜະລິດຕະພັນທັງຫມົດ",
  新到货产品: "ຜະລິດຕະພັນໃຫມ່ -arrival",
  所有商家: "ພໍ່ຄ້າທຸກຄົນ",
  请上传: "ກະລຸນາອັບໂຫລດ",
  请输入: "ກະລຸນາໃສ່",
  忘记密码: "ລືມລະຫັດຜ່ານ",
  记得我: "ຈື່ຂ້ອຍ",
  共_件: "ທັງຫມົດ {0} ສິ້ນ",
  取消订单: "ຍົກເລີກການສັ່ງຊື້",
  申请退款: "ສະຫມັກຂໍເງິນຄືນ",
  未知商家: "ຜູ້ຄ້າທີ່ບໍ່ຮູ້ຈັກ",
  到账: "ບັນຊີ",
  提款订单状态: "ສະຖານະການຖອນເງິນ",
  前_名类别: "ຫມວດຫມູ່ທໍາອິດ {0}",
  取消订单原因_不想要了: "ບໍ່ຕ້ອງການອີກຕໍ່ໄປ",
  取消订单原因_商品错选_多选: "ຄວາມຜິດພາດຂອງຜະລິດຕະພັນ / ຫຼາຍທາງເລືອກ",
  取消订单原因_商品无货: "ອອກ --Of -ogods",
  取消订单原因_地址信息填写错误: "ຕື່ມຂໍ້ມູນໃສ່ໃນຂໍ້ມູນທີ່ຢູ່ຂໍ້ມູນທີ່ຢູ່",
  取消订单原因_商品降价: "ການຫຼຸດຜ່ອນສິນຄ້າ",
  取消订单原因_价格高于其他平台: "ລາຄາແມ່ນສູງກ່ວາເວທີອື່ນໆ",
  取消订单原因_没用_少用_错用优惠: "ບໍ່ມີຫຍັງ / ໃຊ້ສ່ວນຫຼຸດຫນ້ອຍ / ຜິດພາດ",
  退款原因_拍错_多拍_不喜欢:
    "ເອົາສິ່ງທີ່ບໍ່ຖືກຕ້ອງ / ຫນໍ່ໄມ້ສ່ວນຫຼາຍ / ບໍ່ມັກມັນ",
  退款原因_商品成分描述不符: "ລາຍລະອຽດສ່ວນປະກອບຂອງຜະລິດຕະພັນບໍ່ກົງກັນ",
  退款原因_与商家协商一致退款: "ການປຶກສາຫາລືກັບການສົ່ງເງິນຄືນ",
  退款原因_生产日期_保质期与商品描述不符:
    "ວັນທີຜະລິດ / Sheel Life ບໍ່ກົງກັບລາຍລະອຽດຂອງສິນຄ້າ",
  退款原因_图片_产地_批号_规格等描述不符:
    "ຮູບພາບ / ສະຖານທີ່ຂອງຕົ້ນກໍາເນີດ / ຈໍານວນ / ສະເພາະ / ຂໍ້ມູນອື່ນໆ.",
  退款原因_质量问题: "ບັນຫາທີ່ມີຄຸນນະພາບ",
  退款原因_商品变质_发霉_有异物: "ຜະລິດຕະພັນ spoil / mold / ຮ່າງກາຍຕ່າງປະເທດ",
  退款原因_少件_含缺少配件_: "ລາຍການນ້ອຍໆ (ລວມທັງການຂາດອຸປະກອນເສີມ)",
  退款原因_收到商品时有破损_污渍_变形:
    "ເມື່ອໄດ້ຮັບສິນຄ້າ, ມີຄວາມເສຍຫາຍ / ຮອຍເປື້ອນ / ຜິດປົກກະຕິ",
  退款原因_假冒品牌: "ການປອມແປງ",
  退款原因_发票问题: "ບັນຫາໃບເກັບເງິນ",
  退款原因_商家发错货: "ພໍ່ຄ້າສົ່ງສິນຄ້າທີ່ບໍ່ຖືກຕ້ອງ",
  退款原因_预约不到_商家不给退换:
    "ບໍ່ສາມາດແຕ່ງຕັ້ງໃຫ້ແຕ່ງອາຫານ / ພໍ່ຄ້າຈະບໍ່ຖືກສົ່ງຄືນ",
  退款失败: "ຄວາມລົ້ມເຫຼວຂອງການສົ່ງເງິນຄືນ",
  退款处理中: "ການປຸງແຕ່ງເງິນຈ່າຍຄືນ",
  默认: "ໃນຕອນຕົ້ນ",
  产品查询: "ການສອບຖາມຜະລິດຕະພັນ",
  商店LOGO: "ໂລໂກ້ Shop",
  推广码: "ລະຫັດໂປໂມຊັ່ນ",
  查看所有: "ກວດເບິ່ງທັງຫມົດ",
  确认收货成功: "ຢືນຢັນວ່າໃບຮັບເງິນປະສົບຜົນສໍາເລັດ",
  物流公司: "ບໍລິສັດຂົນສົ່ງ",
  物流单号: "ຫມາຍເລກການຂົນສົ່ງສິນຄ້າ",
  发货时间: "ເວລາສົ່ງ",
  请先选择商品规格: "ກະລຸນາເລືອກສະເພາະຜະລິດຕະພັນກ່ອນ",
  个人信息: "ຂໍ້ມູນສ່ວນຕົວ",
  您的用户名: "ຊື່ຜູ້ໃຊ້ຂອງທ່ານ",
  你的名字: "ຊື່ຂອງທ່ານ",
  登录名: "ສັນຍາລັກ",
  你的邮件: "ຈົດຫມາຍຂອງທ່ານ",
  你的密码: "ລະຫັດຜ່ານຂອງທ່ານ",
  重复输入密码: "ເຮັດຄືນລະຫັດຜ່ານ",
  店铺名称: "ຊື່ຮ້ານ",
  证书类型: "ປະເພດ",
  身份证: "ບັດປະຈໍາຕົວ",
  护照: "ຫນັງສືຜ່ານແດນ",
  驾驶执照: "ໃບຂັບຂີ່",
  社会保障卡: "ບັດປະກັນສັງຄົມ",
  证书正面: "ໃບຢັ້ງຢືນໃນທາງບວກ",
  证书反面: "ການພິສູດ",
  确认收货: "ຢືນຢັນການຮັບສິນຄ້າ",
  请选择取消订单的原因必选: "ກະລຸນາເລືອກເຫດຜົນທີ່ຍົກເລີກການສັ່ງຊື້ (ຕ້ອງການ):",
  请选择申请退款的原因必选: "ກະລຸນາເລືອກເຫດຜົນໃນການສະຫມັກຂໍເງິນຄືນ (ຕ້ອງການ):",
  留言: "ຂໍ້ຄວາມ",
  请输入留言: "ກະລຸນາໃສ່ຂໍ້ຄວາມ",
  没有帐户: "ບໍ່ມີບັນຊີ",
  钱包充值: "ກະເປົາເງິນກະເປົາເງິນ",
  输入您的文字: "ໃສ່ຂໍ້ຄວາມຂອງທ່ານ",
  商家登录: "ເຂົ້າສູ່ລະບົບຂອງພໍ່ຄ້າ",
  有关此产品的任何查询: "ສອບຖາມໃດໆກ່ຽວກັບຜະລິດຕະພັນນີ້",
  产品名称: "ຊື່ຜະລິດຕະພັນ",
  你的问题: "ບັນຫາຂອງທ່ານ",
  白银店铺: "ຮ້ານເງິນ",
  铂金店铺: "ຮ້ານ Platinum",
  钻石店铺: "ຮ້ານເພັດ",
  照片: "ຮູບພາບ",
  已退货: "ກັບຄືນມາ",
  邮寄状态: "ສະຖານະພາບ Mail",
  订单摘要: "ຄໍາສັ່ງທີ່ບໍ່ມີຕົວຕົນ",
  收件地址: "ທີ່ຢູ່ລາຍໄດ້",
  订购日期: "ວັນທີສັ່ງຊື້",
  订单状态: "ສະຖານະການສັ່ງຊື້",
  总订单金额: "ຈໍານວນຄໍາສັ່ງທັງຫມົດ",
  邮寄方式: "ວິທີການໄປສະນີ",
  附加信息: "ຂໍ້ມູນເພີ່ມເຕີມ",
  订单详细信息: "ຂໍ້ມູນລະອຽດ",
  交货类型: "ປະເພດການຈັດສົ່ງ",
  进行评论: "ຄໍາເຫັນ",
  已评论: "ເຄົ້າໄດ້ມີຄໍາເຫັນ",
  订单金额: "ຈໍານວນຄໍາສັ່ງ",
  优惠券: "ຄູປອງ",
  统一运费: "ຂົນສົ່ງສິນຄ້າເປັນເອກະພາບ",
  送货地址: "ທີ່ຢູ່ສົ່ງສິນຄ້າ",
  评分: "ຄະແນນ",
  你的意见: "ຄວາມຄິດເຫັນຂອງທ່ານ",
  匿名: "ບໍລິອາ",
  现金: "ເງິນສົດ",
  详情: "ລາຍລະອຽດ",
  收货地址: "ທີ່ຢູ່ຮັບທີ່ຢູ່",
  暂时没有对话: "ບໍ່ມີການສົນທະນາສໍາລັບເວລາ",
  你: "ເຈົ້າ",
  输入您的回复: "ກະລຸນາໃສ່ຄໍາຕອບຂອງທ່ານ",
  删除成功: "ລົບ",
  品牌: "ຍີ່ຫໍ້",
  已缴纳的保证金: "ຂອບໃບເງິນ",
  黄金店铺: "ຮ້ານ Golden",
  没有更多数据: "ບໍ່ມີຂໍ້ມູນອີກຕໍ່ໄປ",
  站内信: "ໃນຈົດຫມາຍ -site",
  系统通知: "ແຈ້ງການລະບົບ",
  邮箱: "ຈົດຫມາຍຈົດຫມາຍ",
  手机号: "ເບີໂທລະສັບ",
  你的手机号: "ເບີໂທລະສັບມືຖືຂອງທ່ານ",
  营业执照: "ໃບອະນຸຍາດດໍາເນີນທຸລະກິດ",
  你的邮箱: "ກ່ອງຈົດຫມາຍຂອງທ່ານ",
  搜索结果: "ຜົນການຄົ້ນຫາ",
  系统公告: "ປະກາດລະບົບ",
  客服: "ບໍລິການລູກຄ້າ",
  消息已撤回: "ຂ່າວໄດ້ຖືກຖອນແລ້ວ",
  物流详情: "ລາຍລະອຽດການຂົນສົ່ງ",
  充值: "ດ້ານເທິງ",
  提现: "ຖົກຖອນ",
  信用分: "ການປ່ອຍສິນເຊື່ອ",
  余额: "ຕົບ",
  佣金: "ຄະນະກໍາມາທິການ",
  继续购物: "ສືບຕໍ່ການຄ້າ",
  订单结算: "ການຊໍາລະສະສາງ",
  加入对比: "ເພີ່ມປຽບທຽບ",
  佣金余额: "ຄະນະກໍາມະການ",
  刷新: "ຈຸດຫມາດ",
  刷新成功: "ຈຸດຫມາດ",
  官网: "ເວັບໄຊທ໌ທາງການ",
  税号: "ຈໍານວນພາສີ",
  订单: "ການສັ່ງຊື້",
  合计: "ທັງຫມົດ",
  系统安全: "ຄວາມປອດໄພຂອງລະບົບ",
  Recharge_Money_Limit:
    "ຈໍານວນເງິນທີ່ເພີ່ມເຕີມຕ້ອງຢູ່ໃນລະຫວ່າງ {min} ແລະ {ສູງສຸດ}",
  限时优惠: "ເວລາຈໍາກັດ",
  高价回收: "ການນໍາກັບມາໃຊ້ໃຫມ່",
  姓名: "ຊື່",
  商品订单号: "ເລກສິນຄ້າ",
  商品在线回收: "ການລີໄຊເຄີນສິນຄ້າອອນລາຍ",
  提交: "ຍື່ນສະເຫນີ",
  回收记录: "ບັນທຶກການຟື້ນຟູ",
  回收状态: "ສະຖານະການຟື້ນຕົວ",
  回收价格: "ລາຄາທີ່ໃຊ້ຄືນໃຫມ່",
  纳税码: "ລະຫັດອາກອນ",
  买家登录: "ເຂົ້າສູ່ລະບົບ",
  买家注册: "ລົງທະບຽນ",
  language: "ຈີນ",
  助力提示:
    "ການຊ່ວຍເຫຼືອຜູ້ຂາຍສົ່ງສາມາດເພີ່ມການສໍາຜັດກັບບັນດາຮ້ານຂອງພວກເຂົາ, ແລະຈໍານວນສະສົມຂອງມື້, ການສໍາຜັດທີ່ສູງກວ່າ.",
  已累计助力: "ຊ່ວຍເຫຼືອສະສົມ",
  今日已助力: "ມື້ນີ້ໄດ້ຊ່ວຍເຫຼືອ",
  立即助力: "ຊ່ວຍເຫຼືອທັນທີ",
  商家助力: "ຊ່ວຍເຫຼືອພໍ່ຄ້າ",
  证件号码: "ເລກປະຈໍາຕົວ",
  证书号码: "ຈໍານວນໃບຢັ້ງຢືນ",
  男鞋: "ເກີບຜູ້ຊາຍ",
  游戏玩具: "ຫຼິ້ນຫຼິ້ນເກມ",
  使用条款: "ເງື່ອນໄຂການນໍາໃຊ້",
  商家: "ພໍ່ຄ້າ",
  已助力: "ໄດ້ຊ່ວຍເຫຼືອ",
  被助力: "ຖືກຊ່ວຍເຫຼືອ",
  用户: "ຜູ້ໃຊ້",
  助力记录: "ຊ່ວຍບັນທຶກ",
  消息类型: "ປະເພດຂໍ້ຄວາມ",
  消息内容: "ເນື້ອໃນຂໍ້ຄວາມ",
  链接: "ການເຊື່ອມໂຍງ",
  文本: "ຂໍ້ຄວາມ",
  清空: "ແຈ່ມແຈ້ງ",
  评论成功: "ຄໍາເຫັນທີ່ປະສົບຜົນສໍາເລັດ",
  扫描二维码: "ສະແກນລະຫັດ QR",
  转入: "ໂອນເຂົ້າ",
  收款: "ຄໍເລັກຊັນ",
  任务下单中心: "ສູນ​ຄໍາ​ສັ່ງ​ວຽກ​ງານ​",
  记录: "ບັນທຶກ",
  任务倒计时: "ວຽກນັບຖອຍຫຼັງ",
  倒计时后自动放弃: "ຍອມແພ້ອັດຕະໂນມັດຫຼັງຈາກການນັບຖອຍຫຼັງ",
  业务码: "ລະຫັດທຸລະກິດ",
  选择商品分类: "ເລືອກປະເພດຜະລິດຕະພັນ",
  可多选: "ມີຫຼາຍທາງເລືອກທີ່ເປັນໄປໄດ້",
  加载分类中: "ກຳລັງໂຫຼດໝວດໝູ່",
  暂无分类: "ຍັງບໍ່ທັນມີການຈັດປະເພດເທື່ອ",
  产品类别: "ປະເພດຜະລິດຕະພັນ",
  账户余额: "ຍອດເງິນໃນບັນຊີ",
  立即结算: "ຕົກລົງທັນທີ",
  任务已自动放弃: "ວຽກງານໄດ້ຖືກປະຖິ້ມໄວ້ໂດຍອັດຕະໂນມັດ",
  商品分类: "ການຈັດປະເພດຜະລິດຕະພັນ",
  订单详情: "ລາຍລະອຽດການສັ່ງຊື້",
  预计收益: "ລາຍຮັບທີ່ຄາດຄະເນ",
  预计佣金收益: "ລາຍ​ຮັບ​ຄະ​ນະ​ກໍາ​ມະ​ການ​ຄາດ​ຄະ​ເນ​",
  收益率: "ຜົນຜະລິດ",
  扣款账户: "ບັນຊີເດບິດ",
  确认结算: "ຢືນຢັນການຕັ້ງຖິ່ນຖານ",
  未选择: "ບໍ່ໄດ້ເລືອກ",
  请选择商品分类: "ກະລຸນາເລືອກປະເພດຜະລິດຕະພັນ",
  下单成功: "ສັ່ງສຳເລັດແລ້ວ",
  下单失败: "ການສັ່ງຊື້ລົ້ມເຫລວ",
  请重试: "ກະລຸນາລອງອີກຄັ້ງ",
  订单记录: "ບັນທຶກການສັ່ງຊື້",
  没有更多了: "ບໍ່ມີອີກແລ້ວ",
  业务号: "ໝາຍເລກທຸລະກິດ",
  商品类型: "ປະເພດຜະລິດຕະພັນ",
  佣金收益: "ລາຍ​ຮັບ​ຄະ​ນະ​ກໍາ​ມະ​",
  待结算: "ການຕັ້ງຖິ່ນຖານທີ່ຍັງຄ້າງຢູ່",
  已结算: "ຕົກລົງ",
  已取消: "ຍົກເລີກ",
  加载失败: "ການໂຫຼດລົ້ມເຫລວ",
  倒计时: "ນັບຖອຍຫຼັງ",
  随机商品: "ລາຍການແບບສຸ່ມ",
  为: "ສໍາລັບ",
  商户助力可提升商品曝光度: "ການຊ່ວຍເຫຼືອຜູ້ຄ້າສາມາດເພີ່ມການເປີດເຜີຍຜະລິດຕະພັນ",
  累计助力越高推荐权重越高:
    "ສູງຂຶ້ນການຊ່ວຍເຫຼືອທີ່ສະສົມ, ນ້ໍາຫນັກຄໍາແນະນໍາສູງຂຶ້ນ.",
  实时助力动态: "ນະໂຍບາຍດ້ານການຊ່ວຍເຫຼືອໃນເວລາຈິງ",
  助力奖励: "ເພີ່ມລາງວັນ",
  随机奖励金额已生成: "ຈໍານວນລາງວັນແບບສຸ່ມໄດ້ຖືກສ້າງຂື້ນ",
  开心收下: "ຍິນດີທີ່ຈະຍອມຮັບມັນ",
  助力已结束: "ການຊ່ວຍເຫຼືອໄດ້ສິ້ນສຸດລົງ",
  助力成功: "ຊ່ວຍເຫຼືອຄວາມສໍາເລັດ",
  成功: "ຄວາມສໍາເລັດ",
  进行中: "ກຳລັງດຳເນີນຢູ່",
  等待: "ລໍຖ້າ",
  助力失败: "ການຊ່ວຍເຫຼືອລົ້ມເຫລວ",
  任務: "ວຽກ",
  下单失败_请稍后重试: "ຄໍາສັ່ງລົ້ມເຫລວ, ກະລຸນາລອງໃຫມ່ໃນພາຍຫຼັງ",
  任务: "ວຽກງານ"
};
